// Sections
import DynamicCollectionSelector from './sections/DynamicCollectionSelector';
import DynamicFaq from './sections/DynamicFaq';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicHighlightsBanner from './sections/DynamicHighlightsBanner';
import DynamicMediaWithText from './sections/DynamicMediaWithText';
import DynamicProductSelector from './sections/DynamicProductSelector';
import DynamicThreeLayeredText from './sections/DynamicThreeLayeredText';
import LocalizationForm from './components/LocalizationForm';
import Sections from '@pixelunion/shopify-sections-manager';
import { Select } from '@knitagency/agency-utils';
import StaticAddresses from './sections/StaticAddresses';
import StaticAnnouncementBar from './sections/StaticAnnouncementBar';
import StaticCollection from './sections/StaticCollection';
import StaticFaq from './sections/StaticFaq';
import StaticFooter from './sections/StaticFooter';
import StaticHeader from './sections/StaticHeader';
import StaticProduct from './sections/StaticProduct';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticSearch from './sections/StaticSearch';

//Components
import StickyHeader from './components/StickyHeader';
import UpsellItem from './components/UpsellItem';

// React
import mountPreact from './preact/mountPreact';
// Plugins
import rimg from '@pixelunion/rimg-shopify';

// init plugins
rimg.init();

// Init global sections
const sections = new Sections();
sections.register(
  'dynamic-collection-selector',
  section => new DynamicCollectionSelector(section),
);
sections.register(
  'dynamic-product-selector',
  section => new DynamicProductSelector(section),
);
sections.register(
  'static-collection',
  section => new StaticCollection(section),
);
sections.register('static-product', section => new StaticProduct(section));
sections.register('static-addresses', section => new StaticAddresses(section));
sections.register(
  'static-announcement-bar',
  section => new StaticAnnouncementBar(section),
);
sections.register('static-header', section => new StaticHeader(section));
sections.register('static-footer', section => new StaticFooter(section));
sections.register('static-faq', section => new StaticFaq(section));
sections.register('static-search', section => new StaticSearch(section));
sections.register(
  'dynamic-featured-collection',
  section => new DynamicFeaturedCollection(section),
);

sections.register('dynamic-faq', section => new DynamicFaq(section));

sections.register(
  'dynamic-highlights-banner',
  section => new DynamicHighlightsBanner(section),
);

sections.register(
  'static-product-recommendations',
  section => new StaticProductRecommendations(section),
);

sections.register(
  'dynamic-three-layered-text',
  section => new DynamicThreeLayeredText(section),
);

sections.register(
  'dynamic-media-w-text',
  section => new DynamicMediaWithText(section),
);

// Init language switcher
const selectors = document.querySelectorAll('[data-country-selector]');
selectors.forEach(selector => new LocalizationForm(selector));

// Init upsells
const upsells = document.querySelectorAll('[data-upsell-product]');
upsells.forEach(item => new UpsellItem(item));

// Init selects
const selects = document.querySelectorAll('[data-select]');
selects.forEach(select => new Select(select));

new StickyHeader();

// Init preact
mountPreact();
